
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.462 2.4a1.2 1.2 0 00-1.2 1.2v9.6l2.4 2.4v-12a1.2 1.2 0 00-1.2-1.2zm-6 4.8a1.2 1.2 0 012.4 0v3.6l-2.4-2.4V7.2zm-4.8 7.2a1.2 1.2 0 012.4 0v6a1.2 1.2 0 01-2.4 0v-6zm-4.8 3.6a1.2 1.2 0 012.4 0v2.4a1.2 1.2 0 01-2.4 0V18zm9.613-3.957c-.013.078-.013.171-.013.357v6a1.2 1.2 0 002.4 0v-6c0-.186 0-.279-.012-.357a1 1 0 00-.831-.83c-.078-.013-.17-.013-.357-.013-.186 0-.278 0-.356.012a1 1 0 00-.831.832z","fill":"#fff","fill-opacity":".5"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.015 2.751a1.2 1.2 0 011.697 0l16.8 16.8a1.2 1.2 0 01-1.697 1.697l-16.8-16.8a1.2 1.2 0 010-1.697z","fill":"#FF4954"}})])
          )
        }
      }
    